export default "__VITE_ASSET__J9MxYqIa__"